export default "__VITE_ASSET__D5yc5mGn__"